<template>
  <window-content v-if="!loading">
    <div class="wrapper-xl m-t-n m-l-n-lg">
      <div class="row">
        <div class="col" style="max-width: 40%; padding-right: 40px">
          <div>
            <erp-s-field
                view="lr"
                label="Solicitação"
                label-width="100px"
            >
              <erp-input size="2" simple-border v-model="solicitacao.id" readonly />
            </erp-s-field>
          </div>

          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Data Registro"
                label-width="100px"
            >
              <erp-input simple-border readonly v-model="solicitacao.createdAt" v-mask="'##/##/#### ##:##:##'" />
            </erp-s-field>
          </div>

          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Data Conclusão"
                label-width="100px"
            >
              <erp-input simple-border v-model="solicitacao.dataConclusao" v-mask="'##/##/#### ##:##:##'" />
            </erp-s-field>
          </div>

          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Código"
                label-width="100px"
            >
              <erp-input simple-border v-model="solicitacao.codigo" />
            </erp-s-field>
          </div>

          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Custo"
                label-width="100px"
            >
              <erp-input simple-border v-model="solicitacao.custo" v-money="money"  />
            </erp-s-field>
          </div>
          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Remoção Local"
                label-width="100px"
            >
              <sl-checkbox v-model="solicitacao.remocaoLocal" />
            </erp-s-field>
          </div>
          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Custo Remoção Local"
                label-width="100px"
            >
              <erp-input simple-border v-model="solicitacao.remocaoLocalValor" v-money="money"  />
            </erp-s-field>
          </div>
          <div class="m-t-xs">
            <erp-s-field
                view="lr"
                label="Custo Total"
                label-width="100px"
            >
              <erp-input simple-border v-model="solicitacao.custoTotal" v-money="money"  />
            </erp-s-field>
          </div>

          <div class="m-t-xs">
            <status-solicitacao-select label-width="100px" :disable="!solicitacao.id" label="Status:" placeholder="Selecione"
                           field-view="lr"
                           v-model="solicitacao.status" />
          </div>

          <div class="m-t-xs">
            <classificacao-select label-width="100px" field-view="lr" label="Classificação" placeholder="Selecione"
                           v-model="solicitacao.classificacao" />
          </div>

          <div class="m-t-xs">
            <erp-s-field view="lr" label="Prazo aceite" label-width="100px">
              <datetime-input date-type="datetime" simple-border v-model="solicitacao.prazoAceite" />
            </erp-s-field>
          </div>
          <div class="m-t-xs">
            <erp-s-field view="lr" label="Prazo recolhimento" label-width="100px">
              <datetime-input date-type="datetime" simple-border v-model="solicitacao.prazoRecolhimento" />
            </erp-s-field>
          </div>
          <div class="m-t-xs">
            <erp-s-field view="lr" label="Prazo entrega" label-width="100px">
              <datetime-input date-type="datetime" simple-border v-model="solicitacao.prazoEntrega" />
            </erp-s-field>
          </div>
        </div>
        <div class="col">
          <div v-if="solicitacao.origem" class="m-b">
            <div class="font-bold small m-b-xs">Origem</div>
            <uf-select field-view="lr" label="UF" label-width="100px" v-model="solicitacao.origem.uf" />
            <erp-s-field view="lr" label="Endereço" label-width="100px" class="m-t-xs">
              <erp-input simple-border v-model="solicitacao.origem.endereco" />
            </erp-s-field>
            <div class="m-t-xs font-11">
              <span class="text-grey">Lat: {{ solicitacao.origem.lat || '—' }} · Lng: {{ solicitacao.origem.lng || '—' }}</span>
              <u-btn size="xs" flat push no-caps color="primary" icon="place" icon-type="fa" icon-style="light"
                     class="m-l-xs" label="Definir no mapa" @click="mostraMapaLocalOrigem(solicitacao.origem)" />
            </div>
          </div>

          <div v-if="solicitacao.destino" class="m-b">
            <div class="font-bold small m-b-xs">Destino</div>
            <uf-select field-view="lr" label="UF" label-width="100px" v-model="solicitacao.destino.uf" />
            <erp-s-field view="lr" label="Endereço" label-width="100px" class="m-t-xs">
              <erp-input simple-border v-model="solicitacao.destino.endereco" />
            </erp-s-field>
            <div class="m-t-xs font-11">
              <span class="text-grey">Lat: {{ solicitacao.destino.lat || '—' }} · Lng: {{ solicitacao.destino.lng || '—' }}</span>
              <u-btn size="xs" flat push no-caps color="primary" icon="place" icon-type="fa" icon-style="light"
                     class="m-l-xs" label="Definir no mapa" @click="mostraMapaLocalDestino(solicitacao.destino)" />
            </div>
          </div>

          <div class="m-t-sm">
            <erp-s-field view="lr" label="Reboquista" label-width="100px">
              <reboquista-input :allow-new="false" v-model="solicitacao.reboquista" />
            </erp-s-field>
          </div>
          <div class="row m-t-sm" v-if="solicitacao.reboquista && solicitacao.reboquista.createdAt">
            <reboquista-info :solicitacao="solicitacao" />
          </div>
        </div>
      </div>

      <div class="row m-t">
        <historico-solicitacao :remocao="remocaoContainer.remocao" :solicitacao="solicitacao" />
      </div>
      <e-row class="m-t-xxl" mr>
        <e-col>
          <erp-s-field
              view="tl"
              label="Observações interna"
              label-width="100px"
          >
            <textarea class="sl-textarea" v-model="solicitacao.observacaoInterna"></textarea>
          </erp-s-field>
        </e-col>
        <e-col>
          <erp-s-field
              view="tl"
              label="Observações Reboquista"
              label-width="100px"
          >
            <textarea class="sl-textarea" v-model="solicitacao.observacaoReboquista"></textarea>
          </erp-s-field>
        </e-col>
      </e-row>
    </div>
    <window-footer class="text-right">
      <div class="inline-block window-actions">
        <u-btn label="Cancelar" icon="chevron-left" icon-type="fa" icon-style="light" flat no-caps
               @click="$uloc.window.close($root.wid)" />
        <u-btn label="Salvar (F2)" icon="save" icon-type="fa" icon-style="light" flat no-caps
               @click="save"
               v-shortkey="['f2']" @shortkey.native="save" :loading="saving" />
      </div>
    </window-footer>
    <local-remocao v-if="showLocalMap" ref="mapLocal" />
  </window-content>
  <window-loading :errors="errors" :status="status" v-else />
</template>

<script>
import {
  // WindowContent,
  // WindowBody
  ErpSField,
  ErpInput, WindowFooter, WindowContent
} from 'uloc-vue-plugin-erp'
import WindowLoading from '../../../layout/window/Loading'
import {findSolicitacao as find} from '../../../../domain/remocao/services'
import {date, UCheckbox} from 'uloc-vue'
import StatusSolicitacaoSelect from '../include/StatusSolicitacaoSelect'
import HistoricoSolicitacao from './SolicitacaoComponent/Historico'
import ReboquistaInfo from './SolicitacaoComponent/ReboquistaInfo'
import ReboquistaInput from '@/components/reboquista/helpers/input/ReboquistaInput'
import ClassificacaoSelect from '@/components/remocao/components/include/ClassificacaoSelect'
import UfSelect from '@/components/remocao/components/include/UfSelect'
import LocalRemocao from '@/components/remocao/components/maps/Local'
import DatetimeInput from '@/reuse/input/Datetime'
import {updateSolicitacaoRemocao} from "@/domain/remocao/services/solicitacao"
import {datetimeToEn} from "@/utils/date"
import {VMoney} from "v-money"
import {convertRealToMoney, REAL_BRL} from "@/utils/money"
import SlCheckbox from "@/reuse/input/Checkbox.vue"
import ERow from "components/layout/components/Row.vue"
import ECol from "components/layout/components/Col.vue"

let mockSolicitacao = {
  id: null,
  origem: {
    uf: null,
    cidade: null,
    localizacao: null,
    endereco: null,
    lat: null,
    lng: null
  },
  destino: {
    uf: null,
    cidade: null,
    localizacao: null,
    endereco: null,
    lat: null,
    lng: null
  },
  reboquista: null,
  classificacao: null,
  codigo: null,
  custo: null,
  remocaoLocalValor: null,
  remocaoLocal: false,
  custoTotal: null,
  prazoAceite: null,
  prazoRecolhimento: null,
  prazoEntrega: null,
  observacaoReboquista: null,
  observacaoInterna: null,
  data: {date: null}
}

export default {
  name: 'RemocaoWindow',
  props: ['id', 'remocao', 'remocaoContainer'],
  directives: {money: VMoney},
  provide: function () {
    return {
      remocaoContainer: this.remocaoContainer
    }
  },
  data () {
    return {
      money: REAL_BRL,
      loading: !!this.id,
      errors: null,
      success: false,
      status: null,
      saving: false,
      showLocalMap: false,
      solicitacao: JSON.parse(JSON.stringify(mockSolicitacao))
    }
  },
  mounted () {
    this.id && find(this.remocao, this.id)
      .then(response => {
        this.loading = false
        let data = response.data
        if (data.data && data.data.date) {
          data.data = date.formatDate(data.data.date, 'DD/MM/YYYY HH:mm:ss')
        }
        if (data.createdAt && data.createdAt.date) {
          data.createdAt = date.formatDate(data.createdAt.date, 'DD/MM/YYYY HH:mm:ss')
        }
        if (data.dataConclusao && data.dataConclusao.date) {
          data.dataConclusao = date.formatDate(data.dataConclusao.date, 'DD/MM/YYYY HH:mm:ss')
        }

        data.custo = 'R$ ' + this.$options.filters.moeda(data.custo || 0)
        data.remocaoLocalValor = 'R$ ' + this.$options.filters.moeda(data.remocaoLocalValor || 0)
        data.custoTotal = 'R$ ' + this.$options.filters.moeda(data.custoTotal || 0)

        // Prazos -> DD/MM/YYYY HH:mm (formato do DatetimeInput)
        ;['prazoAceite', 'prazoRecolhimento', 'prazoEntrega'].forEach(k => {
          if (data[k] && data[k].date) {
            data[k] = date.formatDate(data[k].date, 'DD/MM/YYYY HH:mm')
          }
        })
        // Classificação -> id (o select trabalha com id)
        if (data.classificacao && typeof data.classificacao === 'object') {
          data.classificacao = data.classificacao.id
        }

        // Origem/Destino: a API devolve latitude/longitude/ufOld; normaliza p/ lat/lng/uf usados na edição
        ;['origem', 'destino'].forEach(k => {
          const l = data[k]
          if (l && typeof l === 'object') {
            if (l.lat === undefined || l.lat === null) l.lat = (l.latitude !== undefined ? l.latitude : null)
            if (l.lng === undefined || l.lng === null) l.lng = (l.longitude !== undefined ? l.longitude : null)
            if (l.uf === undefined || l.uf === null) l.uf = (l.ufOld !== undefined ? l.ufOld : null)
          }
        })

        this.solicitacao = data
      })
      .catch((error) => {
        this.$uloc.dialog({
          title: 'Falha ao carregar!',
          color: 'negative',
          message: `Não conseguimos carregar a solicitação de remoção, entre em contato com o administrador.`
        })
        this.loading = false
        this.errors = error.data
        console.error(error, error.data)
      })
  },
  methods: {
    mostraMapaLocal (local, tipo) {
      this.showLocalMap = true
      this.$nextTick(() => {
        this.$refs.mapLocal.show(
          local, tipo === 'origem' ? this.confirmarLocalizacaoOrigem : this.confirmarLocalizacaoDestino
        )
      })
    },
    mostraMapaLocalOrigem (local) {
      this.mostraMapaLocal(local, 'origem')
    },
    mostraMapaLocalDestino (local) {
      this.mostraMapaLocal(local, 'destino')
    },
    confirmarLocalizacaoOrigem (location) {
      this.solicitacao.origem.endereco = location.address
      this.solicitacao.origem.lat = location.latLng.lat
      this.solicitacao.origem.lng = location.latLng.lng
    },
    confirmarLocalizacaoDestino (location) {
      this.solicitacao.destino.endereco = location.address
      this.solicitacao.destino.lat = location.latLng.lat
      this.solicitacao.destino.lng = location.latLng.lng
    },
    save () {
      const solicitacao = JSON.parse(JSON.stringify(this.solicitacao))
      solicitacao.custo = convertRealToMoney(solicitacao.custo)
      solicitacao.remocaoLocalValor = convertRealToMoney(solicitacao.remocaoLocalValor)
      solicitacao.custoTotal = convertRealToMoney(solicitacao.custoTotal)
      let dataConclusao = null
      try {
        dataConclusao = datetimeToEn(solicitacao.dataConclusao)
      } catch (e) {
        dataConclusao = null
      }
      const s = {
        status: solicitacao.status,
        codigo: solicitacao.codigo,
        dataConclusao: dataConclusao,
        custo: solicitacao.custo,
        remocaoLocal: solicitacao.remocaoLocal,
        remocaoLocalValor: solicitacao.remocaoLocalValor,
        custoTotal: solicitacao.custoTotal,
        observacaoReboquista: solicitacao.observacaoReboquista,
        observacaoInterna: solicitacao.observacaoInterna,
      }
      // Só envia reboquista quando definido (setter no backend é não-nulável)
      if (solicitacao.reboquista && solicitacao.reboquista.id) {
        s.reboquista = solicitacao.reboquista.id
      }
      // Classificação (relação, setter nulável): envia o id
      if (solicitacao.classificacao) {
        s.classificacao = typeof solicitacao.classificacao === 'object'
          ? solicitacao.classificacao.id
          : solicitacao.classificacao
      }
      // Prazos (setters nuláveis) -> formato YYYY-MM-DD HH:mm:ss esperado pelo backend
      const toEn = (v) => {
        try {
          return v ? datetimeToEn(v) : null
        } catch (e) {
          return null
        }
      }
      s.prazoAceite = toEn(solicitacao.prazoAceite)
      s.prazoRecolhimento = toEn(solicitacao.prazoRecolhimento)
      s.prazoEntrega = toEn(solicitacao.prazoEntrega)
      // codigo tem setter int não-nulável no backend: só envia quando preenchido
      // (em PATCH o campo omitido não é alterado)
      if (solicitacao.codigo === null || solicitacao.codigo === undefined || solicitacao.codigo === '') {
        delete s.codigo
      }
      // Origem/Destino: monta objeto aninhado só com campos preenchidos.
      // latitude/longitude/endereco têm setters NÃO-nuláveis no backend -> nunca enviar vazio.
      // Não envia local/cidadeOld (mantém o que a Porto preencheu). Em PATCH, campos omitidos ficam inalterados.
      const mapLocalPayload = (loc) => {
        if (!loc || typeof loc !== 'object') return null
        const out = {}
        const has = (v) => v !== undefined && v !== null && v !== ''
        if (has(loc.nome)) out.nome = loc.nome
        if (has(loc.endereco)) out.endereco = loc.endereco
        const lat = has(loc.lat) ? loc.lat : (has(loc.latitude) ? loc.latitude : null)
        const lng = has(loc.lng) ? loc.lng : (has(loc.longitude) ? loc.longitude : null)
        if (has(lat)) out.latitude = String(lat)
        if (has(lng)) out.longitude = String(lng)
        const uf = has(loc.uf) ? loc.uf : loc.ufOld
        if (has(uf)) out.ufOld = uf
        return Object.keys(out).length ? out : null
      }
      const origemPayload = mapLocalPayload(solicitacao.origem)
      const destinoPayload = mapLocalPayload(solicitacao.destino)
      if (origemPayload) s.origem = origemPayload
      if (destinoPayload) s.destino = destinoPayload
      this.saving = true
      updateSolicitacaoRemocao(this.id, s, 'PATCH')
          .then(response => {
            this.saving = false
            this.$uloc.window.emit(this.$root.wid, 'update', response.data)
            this.dg()
          })
          .catch(error => {
            this.saving = false
            this.alertApiError(error)
          })
    }
  },
  computed: {},
  components: {
    ECol,
    ERow,
    SlCheckbox,
    WindowContent,
    WindowFooter,
    ReboquistaInfo,
    ReboquistaInput,
    ClassificacaoSelect,
    UfSelect,
    LocalRemocao,
    DatetimeInput,
    HistoricoSolicitacao,
    StatusSolicitacaoSelect,
    // WindowBody,
    // WindowContent,
    ErpSField,
    ErpInput,
    WindowLoading,
  }
}
</script>
